import type { FinanceDashboardProfitPlanProject } from '@entities/financeDashboard';

export type ProfitProjectSort = 'forecast' | 'plan' | 'deviation';

export const sortProfitProjects = (
    projects: FinanceDashboardProfitPlanProject[],
    sort: ProfitProjectSort
) =>
    [...projects].sort((left, right) => {
        if (sort === 'plan') return right.plannedProfit - left.plannedProfit;
        if (sort === 'deviation') {
            return (
                right.plannedProfit -
                right.profitForecast -
                (left.plannedProfit - left.profitForecast)
            );
        }

        return right.profitForecast - left.profitForecast;
    });
